module.exports = __webpack_public_path__ + "img/java-task.0841fb8d.svg";